import { render, staticRenderFns } from "./ReplyNewContactWithChild.vue?vue&type=template&id=5006b14b"
import script from "./ReplyNewContactWithChild.vue?vue&type=script&lang=ts"
export * from "./ReplyNewContactWithChild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports